var _style, _filter, _filter2, _g, _g2, _defs, _mask, _path, _defs2, _mask2, _path2, _defs3, _mask3, _path3, _defs4, _mask4, _circle, _defs5, _mask5, _circle2, _defs6, _mask6, _circle3, _defs7, _mask7, _circle4, _defs8, _mask8, _circle5, _defs9, _mask9, _circle6, _defs10, _mask10, _g3, _g4, _g5, _path4, _ellipse, _ellipse2, _text, _text2, _g6, _g7, _g8, _g9, _g10, _g11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationCharts2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "charts",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 525 606",
    style: {
      enableBackground: "new 0 0 525 606"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#c);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st4{mask:url(#e_1_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st5{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st6{mask:url(#e_2_);fill:none;stroke:#5175FF;stroke-width:2;}\n\t.st7{filter:url(#Adobe_OpacityMaskFilter_2_);}\n\t.st8{opacity:0.152;mask:url(#e_3_);fill-rule:evenodd;clip-rule:evenodd;fill:#5175FF;enable-background:new    ;}\n\t.st9{filter:url(#Adobe_OpacityMaskFilter_3_);}\n\t.st10{mask:url(#e_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#5175FF;}\n\t.st11{filter:url(#Adobe_OpacityMaskFilter_4_);}\n\t.st12{opacity:0.25;mask:url(#e_5_);fill:none;stroke:#5175FF;enable-background:new    ;}\n\t.st13{filter:url(#Adobe_OpacityMaskFilter_5_);}\n\t.st14{mask:url(#e_6_);fill-rule:evenodd;clip-rule:evenodd;fill:#5175FF;}\n\t.st15{filter:url(#Adobe_OpacityMaskFilter_6_);}\n\t.st16{mask:url(#e_7_);fill-rule:evenodd;clip-rule:evenodd;fill:#5175FF;}\n\t.st17{filter:url(#Adobe_OpacityMaskFilter_7_);}\n\t.st18{mask:url(#e_8_);fill-rule:evenodd;clip-rule:evenodd;fill:#5175FF;}\n\t.st19{filter:url(#Adobe_OpacityMaskFilter_8_);}\n\t.st20{mask:url(#e_9_);fill-rule:evenodd;clip-rule:evenodd;fill:#5175FF;}\n\t.st21{filter:url(#Adobe_OpacityMaskFilter_9_);}\n\t.st22{mask:url(#e_10_);}\n\t.st23{enable-background:new    ;}\n\t.st24{fill:#747B95;}\n\t.st25{font-family:'Arial-BoldMT';}\n\t.st26{font-size:11px;}\n\t.st27{opacity:0.25;fill-rule:evenodd;clip-rule:evenodd;fill:#747B95;enable-background:new    ;}\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:#333950;}\n\t.st29{filter:url(#Adobe_OpacityMaskFilter_10_);}\n\t.st30{mask:url(#h_1_);}\n\t.st31{opacity:0.15;fill:#FEFEFE;enable-background:new    ;}\n\t.st32{filter:url(#i);}\n\t.st33{fill-rule:evenodd;clip-rule:evenodd;fill:#5175FF;}\n\t.st34{opacity:0.15;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;enable-background:new    ;}\n\t.st35{opacity:0.146;fill:none;stroke:#FFFFFF;stroke-width:3.4016;stroke-miterlimit:10;enable-background:new    ;}\n\t.st36{fill:none;stroke:#5CFCD3;stroke-width:20;stroke-linecap:square;stroke-dasharray:302;}\n\t.st37{fill:#5CFCD3;}\n\t.st38{font-size:32px;}\n\t.st39{fill:#FFFFFF;}\n\t.st40{font-size:40px;}\n\t.st41{fill-rule:evenodd;clip-rule:evenodd;fill:#7DA7FF;}\n")), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "131.1%",
    id: "i",
    width: "155.8%",
    x: "-27.9%",
    y: "-7.8%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "erode",
    radius: 12.5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 50,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.293478072 0 0 0 0 0.359720343 0 0 0 0 0.604534647 0 0 0 0.247159091 0"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "148.5%",
    id: "c",
    width: "155.8%",
    x: "-27.9%",
    y: "-12.1%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "erode",
    radius: 12.5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 50,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.293478072 0 0 0 0 0.359720343 0 0 0 0 0.604534647 0 0 0 0.247159091 0"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 46)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b_13_",
    className: "st1",
    d: "M13,14h198c7.2,0,13,5.8,13,13v283c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "b_2_",
    className: "st2",
    d: "M13,14h198c7.2,0,13,5.8,13,13v283c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -36.8,
    y: 42.5,
    width: 280.5,
    height: 240.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -36.8,
    y: 42.5,
    width: 280.5,
    height: 240.5,
    id: "e_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b_3_",
    className: "st2",
    d: "M13,14h198c7.2,0,13,5.8,13,13v283c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -67.3467,
    y1: 653.5593,
    x2: -67.3467,
    y2: 652.5593,
    gradientTransform: "matrix(280.496 0 0 -240.492 18993.9023 157218.2812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#024AFF",
      stopOpacity: 0.148
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B77CF",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-36.8,254.7L56.5,223l55.5-81.9l56.5,18l75.2-116.7V283l-280.5-1L-36.8,254.7z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: -37.1,
    y: 39.1,
    width: 281.8,
    height: 243.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -37.1,
    y: 39.1,
    width: 281.8,
    height: 243.9,
    id: "e_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b_4_",
    className: "st2",
    d: "M13,14h198c7.2,0,13,5.8,13,13v283c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-36.8,254.7L56.5,223l55.5-81.9l56.5,18l75.2-116.7V283"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 56,
    y: 14,
    width: 114,
    height: 250
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 14,
    width: 114,
    height: 250,
    id: "e_3_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b_5_",
    className: "st2",
    d: "M13,14h198c7.2,0,13,5.8,13,13v283c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M112,14h1v250h-1V14z M56,14h1v250h-1V14z M169,14h1v250h-1V14z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    filterUnits: "userSpaceOnUse",
    x: 106,
    y: 135,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 135,
    width: 12,
    height: 12,
    id: "e_4_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b_6_",
    className: "st2",
    d: "M13,14h198c7.2,0,13,5.8,13,13v283c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 112,
    cy: 141,
    r: 6
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_4_",
    filterUnits: "userSpaceOnUse",
    x: 94,
    y: 123,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 123,
    width: 36,
    height: 36,
    id: "e_5_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b_7_",
    className: "st2",
    d: "M13,14h198c7.2,0,13,5.8,13,13v283c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 112,
    cy: 141,
    r: 17.5
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_5_",
    filterUnits: "userSpaceOnUse",
    x: 50,
    y: 217,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 217,
    width: 12,
    height: 12,
    id: "e_6_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b_8_",
    className: "st2",
    d: "M13,14h198c7.2,0,13,5.8,13,13v283c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 56,
    cy: 223,
    r: 6
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_6_",
    filterUnits: "userSpaceOnUse",
    x: 163,
    y: 153,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 153,
    width: 12,
    height: 12,
    id: "e_7_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b_9_",
    className: "st2",
    d: "M13,14h198c7.2,0,13,5.8,13,13v283c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  })))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 169,
    cy: 159,
    r: 6
  })), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_7_",
    filterUnits: "userSpaceOnUse",
    x: 218,
    y: 68,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 218,
    y: 68,
    width: 12,
    height: 12,
    id: "e_8_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b_10_",
    className: "st2",
    d: "M13,14h198c7.2,0,13,5.8,13,13v283c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  })))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 224,
    cy: 74,
    r: 6
  })), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_8_",
    filterUnits: "userSpaceOnUse",
    x: -6,
    y: 236,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: 236,
    width: 12,
    height: 12,
    id: "e_9_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b_11_",
    className: "st2",
    d: "M13,14h198c7.2,0,13,5.8,13,13v283c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  })))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 0,
    cy: 242,
    r: 6
  })), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_9_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 274,
    width: 224,
    height: 36.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 274,
    width: 224,
    height: 36.1,
    id: "e_10_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b_12_",
    className: "st2",
    d: "M13,14h198c7.2,0,13,5.8,13,13v283c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 104.15 306)",
    className: "st24 st25 st26"
  }, "Jan")), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 45.779 306)",
    className: "st24 st25 st26"
  }, "Dec")), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1.831055e-04 306)",
    className: "st24 st25 st26"
  }, "Nov")), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 158.308 306)",
    className: "st24 st25 st26"
  }, "Feb")), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 198.2973 306)",
    className: "st24 st25 st26"
  }, "Mar")), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M0,282h224v1H0V282z M112,274h1v8h-1V274z M56,274h1v8h-1V274z M168,274h1v8h-1V274z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f_1_",
    className: "st1",
    d: "M13,14h198c7.2,0,13,5.8,13,13v120c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f_2_",
    className: "st28",
    d: "M13,14h198c7.2,0,13,5.8,13,13v120c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_10_",
    filterUnits: "userSpaceOnUse",
    x: -67,
    y: 14,
    width: 355.1,
    height: 75
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -67,
    y: 14,
    width: 355.1,
    height: 75,
    id: "h_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f_3_",
    className: "st2",
    d: "M13,14h198c7.2,0,13,5.8,13,13v120c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M0,14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M-67,85v4h95.1v-4H-67z M193,85v4h95.1v-4H193z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(276)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "j_2_",
    className: "st1",
    d: "M13,14h198c7.2,0,13,5.8,13,13v457c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "j_1_",
    className: "st33",
    d: "M13,14h198c7.2,0,13,5.8,13,13v457c0,7.2-5.8,13-13,13H13c-7.2,0-13-5.8-13-13V27 C0,19.8,5.8,14,13,14z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M276,196h224v1H276V196z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st35",
    cx: 392,
    cy: 103.5,
    rx: 73.5,
    ry: 72
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "a_1_",
    className: "st36",
    cx: 394.4,
    cy: 98.2,
    rx: 68.9,
    ry: 66.7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 355 116)",
    className: "st37 st25 st38"
  }, "87%")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 352 250)",
    className: "st39 st25 st40"
  }, "98k")), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(308 282)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7,14L7,14c3.9,0,7,3.1,7,7l0,0c0,3.9-3.1,7-7,7l0,0c-3.9,0-7-3.1-7-7l0,0C0,17.1,3.1,14,7,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M36,14h117c3.9,0,7,3.1,7,7l0,0c0,3.9-3.1,7-7,7H36c-3.9,0-7-3.1-7-7l0,0C29,17.1,32.1,14,36,14z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(308 316)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7,14L7,14c3.9,0,7,3.1,7,7l0,0c0,3.9-3.1,7-7,7l0,0c-3.9,0-7-3.1-7-7l0,0C0,17.1,3.1,14,7,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M36,14h69c3.9,0,7,3.1,7,7l0,0c0,3.9-3.1,7-7,7H36c-3.9,0-7-3.1-7-7l0,0C29,17.1,32.1,14,36,14z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(308 350)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7,14L7,14c3.9,0,7,3.1,7,7l0,0c0,3.9-3.1,7-7,7l0,0c-3.9,0-7-3.1-7-7l0,0C0,17.1,3.1,14,7,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M36,14h117c3.9,0,7,3.1,7,7l0,0c0,3.9-3.1,7-7,7H36c-3.9,0-7-3.1-7-7l0,0C29,17.1,32.1,14,36,14z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(308 384)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7,14L7,14c3.9,0,7,3.1,7,7l0,0c0,3.9-3.1,7-7,7l0,0c-3.9,0-7-3.1-7-7l0,0C0,17.1,3.1,14,7,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M36,14h65c3.9,0,7,3.1,7,7l0,0c0,3.9-3.1,7-7,7H36c-3.9,0-7-3.1-7-7l0,0C29,17.1,32.1,14,36,14z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(308 418)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7,14L7,14c3.9,0,7,3.1,7,7l0,0c0,3.9-3.1,7-7,7l0,0c-3.9,0-7-3.1-7-7l0,0C0,17.1,3.1,14,7,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M36,14h117c3.9,0,7,3.1,7,7l0,0c0,3.9-3.1,7-7,7H36c-3.9,0-7-3.1-7-7l0,0C29,17.1,32.1,14,36,14z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M63.5,496.3l12-1.6h2.4l13,1.6v4.3H63.5V496.3z M99,430.2h7.6l27.5,70.5h-11.9l-23.8-62.1l2.9-0.4L77,500.6 h-5.7L99,430.2z M85.1,473h32.3l2,4.9H83.2L85.1,473z M108.4,496.3l14.9-1.6h2.9l14.9,1.6v4.3h-32.7V496.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M165.3,473.1c5-1.5,12.6-3.4,18.6-4.4v3.8c-5.4,1-12.4,2.9-16,4.2c-10.3,3.5-11.7,7.5-11.7,10.7 c0,5.5,4.1,7.7,9.5,7.7c4,0,6.4-1.3,13.6-5.8l2.6-1.7l1.6,2.1l-3.6,3.2c-7.1,6.2-11.1,9.2-18.5,9.2c-8.8,0-16-4.4-16-13.1 C145.4,482.9,149.1,478.1,165.3,473.1z M178.7,491.1v-24c0-10.2-3.2-12.7-11.1-12.7c-2.8,0-6.3,0.3-10.8,1.9l5.1-3.3l-2.9,8.8 c-1,3.4-3,5.1-6.3,5.1c-3.3,0-5.3-1.6-5.6-4.3c2.1-8,11.1-13,23.5-13c12.6,0,18.6,5,18.6,18.2v22.3c0,4.5,1.6,6.1,4.3,6.1 c2,0,3.3-0.9,4.6-2.3l1.5,1c-2.9,4.1-5.3,6.8-9.6,6.8C183.1,501.7,178.8,497.6,178.7,491.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M62.8,511.1v-5.2h136.6v5.2H62.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationCharts2);
export default __webpack_public_path__ + "static/media/illustration-charts-2.1cfe1a46.svg";
export { ForwardRef as ReactComponent };